import { styled, alpha } from '@mui/material/styles'
import { DataGridPremium, DataGridPremiumProps } from '@mui/x-data-grid-premium'
import { DataGridPro, DataGridProProps } from '@mui/x-data-grid-pro'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

export const HicDataGridPro: typeof DataGridPro = styled(DataGridPro)(({ theme }) => ({
  fontSize: '0.875rem',
  fontFamily: 'Roboto',
  fontWeight: 400,

  '& .MuiDataGrid-columnHeaders': {
    boxShadow: `0 0.125rem 0.25rem ${alpha(theme.palette.common.black, 0.1)}`,
    zIndex: 2,
  },
  '& .MuiDataGrid-columnHeader': {
    color: 'var(--DarkImperialBlue)',
    fontFamily: 'Roboto',
    fontWeight: 500,
    fontSize: '0.875rem',
    lineHeight: '1rem',
  },

  '& .MuiDataGrid-cell:focus, .MuiDataGrid-cell:focus-within, .MuiDataGrid-columnHeader:focus, .MuiDataGrid-columnHeader:focus-within': {
    outlineColor: theme.palette.secondary.main,
  },
})) as typeof DataGridPro

export const HicDataGridPremium: typeof DataGridPremium = styled(DataGridPremium)(({ theme }) => ({
  fontSize: '0.875rem',
  fontFamily: 'Roboto',
  fontWeight: 400,
  '& .MuiDataGrid-columnHeaders': {
    boxShadow: `0 0.125rem 0.25rem ${alpha(theme.palette.common.black, 0.1)}`,
    zIndex: 2,
  },
  '& .MuiDataGrid-aggregationColumnHeaderLabel': {
    display: 'none',
  },
  '& .MuiDataGrid-columnHeader': {
    color: 'var(--DarkImperialBlue)',
    fontFamily: 'Roboto',
    fontWeight: 500,
    fontSize: '0.875rem',
    lineHeight: '1rem',
  },

  '& .MuiDataGrid-cell:focus, .MuiDataGrid-cell:focus-within, .MuiDataGrid-columnHeader:focus, .MuiDataGrid-columnHeader:focus-within': {
    outlineColor: theme.palette.secondary.main,
  },
  '& .bill-group-row': {
    backgroundColor: 'var(--GridGroupBg)',
    '&:hover': {
      backgroundColor: 'var(--GridGroupBg-hover)',
    },
    '& .bill-group-row': {
      backgroundColor: 'var(--GridGroupBg)',
      '&:hover': {
        backgroundColor: 'var(--GridGroupBg-hover)',
      },
    },
  },

  '& .bill-group-row-disabled': {
    backgroundColor: 'var(--GridGroupBg-disabled)',
    '& .MuiTypography-titleXSmall': {
      opacity: 0.75,
    },
    '&:hover': {
      backgroundColor: 'var(--GridGroupBg-disabled)',
    },
  },

  '& .bill-group-item-row': {
    opacity: 1,
  },
  '& .bill-group-item-row-disabled': {
    opacity: 0.6,
  },
})) as typeof DataGridPremium

export const useHicCommonDataGridProps = () => {
  const { t } = useTranslation()

  const hicCommonDataGridProProps: Partial<DataGridProProps> = {
    rowHeight: 40,
    columnHeaderHeight: 40,
    localeText: { noRowsLabel: t('commons.no_rows') },
  }

  const hicCommonDataGridPremiumProps: Partial<DataGridPremiumProps> = {
    rowHeight: 40,
    columnHeaderHeight: 40,
    localeText: { noRowsLabel: t('commons.no_rows') },
  }

  return { hicCommonDataGridProProps, hicCommonDataGridPremiumProps}
}
